import { useEffect, useState } from 'react';
import { ITitle } from './ITitle';

export default function CustomisedTitleFont14({ title }: ITitle) {
    return (
        <span className="font-bold text-sm text-[var(--primary-text-color)]">{title}</span>
    );
}
